module.exports = __webpack_public_path__ + "static/media/customer-success-doro-alt-feature.03c80b3d.jpg";